import Manage from "..";

export default function AllAssists() {
  return (
    <Manage
      title={"Road Assistance"}
      subtitle={"All"}
      description={"List of recent requests"}
      actions={<></>}
    >
      <div className="flex flex-row p-8">
        <div className="">Comming Soon</div>
      </div>
    </Manage>
  );
}
